import { isMyWMApp } from "utils-lib/isMyWMApp"
import { withAuthentication as withMyWMAuthentication } from "./myWMAuthentication"
import { withAuthentication as aemSPAAuthentication } from "./aemSPAAuthentication"

/**
 * A higher-order component that provides authentication for the wrapped component.
 * @param {React.Component} WrappedComponent - The component to be wrapped with authentication.
 * @returns {React.Component} - The wrapped component with authentication.
 */
export const withAuthentication = (WrappedComponent) => {
  if (isMyWMApp) {
    return withMyWMAuthentication(WrappedComponent)
  }

  return aemSPAAuthentication(WrappedComponent)
}
